import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  template: `
    <div class="header">
     <h2>{{ data.time }}</h2>
     <button class="download-button" (click)="downloadImage()">
      <i class="fa fa-download"></i> Download
     </button>
    </div>
    <img [src]="data.imageUrl" alt="Detailed view" />
    <p>{{ data.details }}</p>
  `,
  styles: [`
    img { width: 100%; border-radius: 8px; }
    .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .download-button {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .download-button i {
        margin-right: 5px;
    }
  `]
})
export class PopupComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
  downloadImage() {
    const link = document.createElement('a');
    link.href = this.data.imageUrl;
    link.download = `image_${this.data.time}.jpg`;
    link.click();
  }
}
